import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export const SearchIcon = React.forwardRef((props, ref) => (
  <SvgIcon ref={ref} viewBox="0 0 19.18 19.32" {...props}>
    <path d="M12.7,14.08a7,7,0,0,0,4-12.31A7.05,7.05,0,0,0,12.17.08h0a7,7,0,0,0-7,7,7,7,0,0,0,1.56,4.4l0,.06L5.31,13l-.44-.44a.6.6,0,0,0-.41-.17.58.58,0,0,0-.4.17L.49,16.13A1.85,1.85,0,0,0,0,17.46a1.86,1.86,0,0,0,3.12,1.29l3.57-3.57a.57.57,0,0,0,0-.8l-.58-.58,1.44-1.43,0,0A6.94,6.94,0,0,0,12.7,14.08Zm-7.27.76L2.32,18a.69.69,0,0,1-.5.2.73.73,0,0,1-.52-.21.72.72,0,0,1,0-1l3.17-3.17,1,1Zm.85-7.75A5.88,5.88,0,1,1,12.15,13,5.88,5.88,0,0,1,6.28,7.09Z" />
  </SvgIcon>
));

export default React.memo(SearchIcon);
